import { toast } from "sonner";
import { useSocketIo } from "./useSocketIo";

/**
 * Real-time approval/notification toasts.
 *
 * Migrated from raw WebSocket → Socket.IO singleton (P1, iter 73).
 * Backend `core/realtime.py` mirrors every legacy `broadcast_realtime_update`
 * call to Socket.IO as well, so toasts now arrive over the v2 transport
 * without changing the wire shape.
 */
export function useNotificationSocket(user) {
  useSocketIo({
    notification: (data) => {
      // shape from notifications_ws.send_notification: { type, title, message, ... }
      // shape from core.realtime: { type: 'notification', notification_type, title, message }
      showNotificationToast(data || {});
    },
  }, { enabled: !!user?.user_id });
}

function showNotificationToast(data) {
  const notifType = (data.notification_type || data.type || "").toUpperCase();
  const title = data.title || "Notification";
  const message = data.message || data.body || "";

  if (notifType.includes("APPROVED")) {
    toast.success(title, { description: message, duration: 6000 });
  } else if (notifType.includes("REJECTED")) {
    toast.error(title, { description: message, duration: 8000 });
  } else if (notifType.includes("ON_HOLD") || notifType.includes("HOLD")) {
    toast.warning(title, { description: message, duration: 6000 });
  } else if (notifType.includes("RESOLVED")) {
    toast.success(title, { description: message, duration: 6000 });
  } else {
    toast.info(title, { description: message, duration: 5000 });
  }
}
